import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  theme: {
    primary: '#4d1d79',
    secondary: '#BFADA5',
    accent: '#D8EBF1',
    info: '#5B5C79'
  },
  iconfont: 'md'
})
